<template>
  <div :class="$style.topPost">
    <img :src="loading === 'success' ? image : '/images/skeleton/topPost.svg'" :alt="loading === 'success' ? title : ''">

    <Transition name="fade">
      <div
        v-show="loading === 'success'"
        :class="$style.topPostContent"
      >
        <h2 :class="['h3', $style.topPostTitle]">{{ title }}</h2>
        <div :class="$style.topPostCaption">
          {{ caption }}
        </div>

        <div :class="$style.topPostDate">{{ date }}</div>
      </div>
    </Transition>

    <Transition name="fade">
      <UiButton
        type="circle"
        color="transparent"
        :class="$style.topPostAction"
        :to="localePath(`/blog/${_id}`)"
        v-show="loading === 'success'"
      >
        <template #label>
          {{ t('blog.more') }}
        </template>
        <template #preppendIcon>
          <UiIconsArrowRight />
        </template>
      </UiButton>
    </Transition>
    <Transition name="fade">
      <nuxt-link
        :class="$style.topPostMAction"
        v-show="loading === 'success'"
        :to="localePath(`/blog/${_id}`)"
      >
        <UiIconsArrowRight />
      </nuxt-link>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import type { TopPostParams } from './index.js';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const localePath = useLocalePath();

const props = defineProps<TopPostParams>();
const { $moment } = useNuxtApp();
const date = computed(() =>
  props.date
    ? $moment(props.date).format('DD.MM.YYYY')
    : ''
);
const caption = computed(() =>
  (props.caption || '').replace('[&hellip;]', '...')
);
</script>

<style lang="scss" module>
  .topPost {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 26px;
    border-radius: 24px;
    overflow: hidden;
    margin-bottom: 16px;
    color: rgba(255, 255, 255, 0.80);
    padding: 230px 64px 64px 32px;
    height: 80vh;
    max-height: 540px;

    @media (max-width: 767px) {
      padding: 16px;
      min-height: calc(var(--visual-viewport-height) - 126px - 16px);
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    &Title {
      margin: 0 0 12px 0;
      color: #fff;

      @media (max-width: 767px) {
        font-size: 26px;
      }
    }

    &Caption {
      max-width: 620px;
      margin-bottom: 20px;

      @media (max-width: 767px) {
        font-size: 12px;
      }
    }

    &Date {
      @media (max-width: 767px) {
        font-size: 12px;
      }
    }

    &Content {
      z-index: 2;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &Action {
      z-index: 2;
      position: relative;
      flex-shrink: 0;

      @media (max-width: 767px) {
        display: none;
      }
    }

    &MAction {
      z-index: 2;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 42px;
      height: 42px;
      border-radius: 42px;
      background-color: rgba(255, 255, 255, 0.3);
      color: #fff;
      text-decoration: none;

      @media (min-width: 768px) {
        display: none;
      }

      svg {
        width: 12px;
        height: auto;
      }
    }
  }

  .itemCat {
    z-index: 2;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 28px;
    padding: 7px 12px;
    margin-bottom: 16px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.42);
    backdrop-filter: blur(7.5px);
    color: #fff;
    font-family: 'Gilroy';
    font-size: 12px;
    font-weight: 400;

    svg {
      flex-shrink: 0;
      width: 10px;
      height: auto;
    }
  }
</style>